export const INITIAL_ITEMS_PER_PAGE = 24;
export const DEFAULT_ITEMS_PER_PAGE = 18;
export const DEFAULT_PAGE_NUMBER = 1;
